import Dexie from 'dexie';
import { MunicipioUfSchema, SafraSchema } from './schemas';
import { migrationManager } from './migrations/MigrationManager';

class AppDatabase extends Dexie {
  constructor() {
    super('ClienteRuralProjetos');

    this.version(1).stores({
      safras: SafraSchema,
      municipios: MunicipioUfSchema,
    });

    this.safras = this.table('safras');
    this.municipios = this.table('municipios');
  }

  async initialize() {
    await migrationManager.runMigrations(this);
    return this;
  }
}

export const db = new AppDatabase();
